module.exports = __webpack_public_path__ + "9779d9a1/img/dollar-icon.35c9d638.svg";